import React from 'react';
import { DiabetesPageTemplate } from './DiabetesPageTemplate';
import { diabetesImages } from './diabetesPageData';

const DiabetesPrevention = () => {
  return (
    <DiabetesPageTemplate
      eyebrow="Prevention"
      title="Diabetes Prevention"
      intro="Did you know that diabetes prevention is often built on simple habits like eating healthy, staying physically active, sleeping well, and reducing excess weight? The challenge is consistency, not complexity."
      heroSummary="Type 1 diabetes cannot usually be prevented, but the risk of Type 2 diabetes can often be reduced through sustained lifestyle changes."
      heroImage={diabetesImages.heroMain}
      heroAlt="Healthy lifestyle and diabetes prevention"
      sections={[
        {
          title: 'How To Prevent Diabetes?',
          paragraphs: [
            "Did you know that diabetes prevention is just as simple as eating healthy, being physically active and losing a few extra pounds? Unfortunately, most people get intimidated when it comes to how to control diabetes but as you can see, it's really just a lifestyle change. Yes, it surely takes some getting used to but think about all the serious health complications you'll avoid. That includes permanent nerve, kidney and heart damage. Read on as we tell you how to prevent diabetes, and if you have it already, then how to control diabetes.",
            "Type 1 diabetes is the kind of diabetes that cannot be prevented but the impact can be reasonably reduced by managing the person's health well. On the contrary, one's risk for type 2 diabetes could be largely lowered by taking some simple yet important measures, which mainly include modifications to the lifestyle.",
          ],
          image: diabetesImages.causeImg,
          imageAlt: 'Lifestyle causes and prevention of diabetes',
          imageCaption: 'Prevention relies on a few practical habits done consistently over time.',
        },
        {
          title: 'Here Are Some Easy Steps To Prevent Diabetes',
          columns: [
            {
              title: 'Increase Your Physical Activity',
              items: [
                'This will help you lower the body weight and blood sugar, and makes the body cells, especially muscle cells, more sensitive to insulin.',
                'This will help you keep your blood pressure and cholesterol levels under control.',
              ],
            },
            {
              title: 'Start A Healthy And Balanced Diet',
              items: [
                'Eat a variety of foods and control the portion size instead of excluding a particular food.',
                'By having fibre rich foods such as fruits, vegetables, whole grains, beans, nuts and seeds, you can not only lower the risk of heart disease, but also control your blood sugar better. Fibre rich food aids in weight loss, as they make the person feel full on consumption.',
                'Take at least half of the total grains as whole grains instead of having more of processed or refined grains as the whole grains are shown to reduce risk of diabetes.',
              ],
            },
            {
              title: 'Lose Excess Weight',
              items: [
                'It helps maintain your blood pressure, and bring cholesterol under control.',
                'It also improves mobility, reduces stress and joint damage.',
              ],
            },
            {
              title: 'Regulate Your Sleeping Patterns',
              items: [
                'Sleeping for less than 6 hours can create imbalance between the hormones regulating food intake and energy levels, thereby increasing the risk of diabetes; nevertheless, long sleeping durations for 9 hours or more may also increase risk for diabetes.',
                'Any causes for these sleep alterations should be evaluated and treated.',
              ],
            },
            {
              title: 'Quit Smoking',
              items: [
                'Through various mechanisms, smoking can increase the abdominal fat deposition and insulin resistance, a blockage of insulin actions.',
                'Quitting smoking is therefore an important measure to decrease your risk for diabetes.',
              ],
            },
          ],
        },
      ]}
    />
  );
};

export default DiabetesPrevention;
